const cfg = {
  idp_pool_id: "us-east-1:4f83e336-45de-445c-a247-c6ac8e0a7f57",
  user_pool_id: "us-east-1_EIRF3kqbq",
  user_pool_client_id: "3b3l42tko1ub7vig2nd3cmrvs",
  user_pool_domain: "auth.getpoln.com",
  redirect_sign_in: "http://localhost:3200/deals/creator",
  redirect_sign_out: "http://localhost:3200/deals/creator",
  s3_bucket: "pp-userfiles",
  s3_region: "us-east-1",
  app_base_url: "http://localhost:3200"
};

// if (window && window.location.origin.includes('qa-web')) {
//   cfg.redirect_sign_in = "https://qa-web.datayno.co/deals/creator";
//   cfg.redirect_sign_out = "https://qa-web.datayno.co/deals/creator";
// } else if (window && !window.location.origin.includes('qa-web') && !window.location.origin.includes('localhost')) {
  cfg.redirect_sign_in = "https://datadyno.co/deals/creator";
  cfg.redirect_sign_out = "https://datadyno.co/deals/creator";
// }

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: cfg.user_pool_id,
      userPoolClientId: cfg.user_pool_client_id,
      identityPoolId: cfg.idp_pool_id,
      loginWith: {
        oauth: {
          domain: cfg.user_pool_domain,
          scopes: ['openid', 'email', 'profile', 'phone', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [cfg.redirect_sign_in],
          redirectSignOut: [cfg.redirect_sign_out],
          responseType: 'code'
        },
        username: 'true',
        email: 'true',
      },
    }
  },
  Storage: {
    S3: {
      bucket: cfg.s3_bucket,
      region: cfg.s3_region,
    }
  }
};

export default awsconfig;
